<template>
  <div class="collect_box">
    <div v-if="true || list.length">
      <ul class="classify_box">
        <li
          v-for="(item, index) in categoryList" :key="item.id" class="classify_item"
          :class="{ active: activeIndex === index }" @click="changeActive(index)">{{ item.name }}</li>
      </ul>
      <ul class="model_box">
        <li class="model_item">111</li>
        <li class="model_item">111</li>
        <li class="model_item">111</li>
        <li class="model_item">111</li>
        <li class="model_item">111</li>
      </ul>
    </div>
    <NoData v-else>您还未收藏任何作品</NoData>
  </div>
</template>

<script>
import NoData from './NoData.vue'

export default {
  name: 'Collect',

  components: { NoData },

  data () {
    return {
      activeIndex: 0,
      list: []
    }
  },

  computed: {
    categoryList () {
      return this.$store.state.operational.categoryArr
    }
  },

  methods: {
    changeActive (index) {
      this.activeIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.collect_box { height: 100%; padding: 40px 60px;
  @media (max-width: 1800px) {
    .model_box{
      .model_item {
        &:nth-child(4n) { margin-right: 20px; }
      }
    }
  }

  .classify_box { margin-bottom: 25px; font-size: 16px; font-weight: 500; color: #666; }
  .classify_item { position: relative; display: inline-block; margin-right: 54px; cursor: pointer;
    &.active { color: #333; &::after { display: inline-block; } }
    &::after { position: absolute; bottom: -6px; left: 50%; display: none; width: 50px; height: 4px; margin-left: -25px; content: ''; border-radius: 2px; }
    &:nth-child(1) { &::after { background-color: $top_classify_color1; } }
    &:nth-child(2) { &::after { background-color: $top_classify_color2; } }
    &:nth-child(3) { &::after { background-color: $top_classify_color3; } }
    &:nth-child(4) { &::after { background-color: $top_classify_color4; } }
    &:nth-child(5) { &::after { background-color: $top_classify_color5; } }
  }

  .model_item { display: inline-block; width: 280px; height: 316px; margin: 0 20px 20px 0; background-color: #ccc; border-radius: 8px;
    &:nth-child(4n) { margin-right: 0; }
  }
}
</style>
